export function schema_operations_sur_colonnes(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			colonnes: {
				type: "array",
				format: "table",
				title: "Opérations",
				items: {
					type: "object",
					title: "Opération",
					properties: {
						colonne: {
							title: "Colonne",
							type: "string",
							options: {
								inputAttributes: {
									class: "form-control dropdown-colonne",
								},
							},
						},
						operation: {
							type: "string",
							title: "Opération"
						},
					},
				},
			},
		},
	};
}
